import { useState, useEffect } from 'react';

export const useSessionStorage = (key, initialValue) => {
  const [state, setState] = useState(() => {
    const storedValue = sessionStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : initialValue;
  });

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.storageArea === sessionStorage && e.key === key) {
        setState(e.newValue ? JSON.parse(e.newValue) : null);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [key]);

  const setSessionStorageState = (value) => {
    const valueToStore = value instanceof Function ? value(state) : value;
    setState(valueToStore);
    sessionStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [state, setSessionStorageState];
};
